<template>
    <el-dialog
        title="供应商评分表"
        class="key-data-trans-legal-dialog"
        :append-to-body="true"
        :visible.sync="visible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="!confirmLoading && !pdfTransforming"
        ref="dialogRef"
        width="98%"
        top="3vh"
        :before-close="close"
    >
        <div v-loading="loading" class="content-wrap" ref="contentRef">
            <div class="title-container">
                <span class="title">供应商基础信息</span>
            </div>
            <BaseInfo ref="biRef" :pdfTransforming="pdfTransforming" />
            <div class="title-container">
                <span class="title">资质信息</span>
            </div>
            <el-table :data="qlfTableData" :span-method="arraySpanMethod" border header-row-class-name="header-bg" class="margin-bottom-20">
                <el-table-column prop="businessType" label="业务类型" width="120"></el-table-column>
                <el-table-column prop="propertyNature" label="主体性质" width="120"></el-table-column>
                <el-table-column prop="zzlx" label="资质类型"></el-table-column>
                <el-table-column prop="qualificationFlag" label="是否符合" width="180">
                    <template slot="header" slot-scope="scope">
                        <span class="required">*</span><span>是否符合</span>
                    </template>
                    <template slot-scope="scope">
                        <el-radio v-model="scope.row.qualificationFlag" label="符合">符合</el-radio>
                        <el-radio v-model="scope.row.qualificationFlag" label="不符合">不符合</el-radio>
                    </template>
                </el-table-column>
                <el-table-column prop="sm" label="说明"></el-table-column>
                <el-table-column prop="resultFlag" label="结果" width="100"></el-table-column>
            </el-table>
            <div class="title-container">
                <span class="title">能力评估</span>
                <div class="sub-title">1、运营能力（本项由运营平台负责修订）</div>
            </div>
            <el-table :data="operationTableData" :span-method="opArraySpanMethod" border header-row-class-name="header-bg">
                <el-table-column prop="pgwd" label="评估维度" width="120"></el-table-column>
                <el-table-column prop="wdsm" label="维度说明">
                    <template slot-scope="scope">
                        <el-table v-if="scope.$index === 0" :data="scope.row.customerList" header-row-class-name="header-bg">
                            <el-table-column prop="customerName" label="客户名称">
                                <template slot="header" slot-scope="cuScope">
                                    <span class="required">*</span><span>客户名称</span>
                                </template>
                                <template slot-scope="cuScope">
                                    <span v-if="pdfTransforming">{{ cuScope.row.customerName }}</span>
                                    <el-input v-else :class="cuInputError(cuScope.row.customerName, 'customerName', cuScope.row, cuScope.$index) ? 'is-error' : ''" v-model.trim="cuScope.row.customerName" placeholder="客户名称"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="scale" label="运作规模">
                                <template slot="header" slot-scope="cuScope">
                                    <span class="required">*</span><span>运作规模</span>
                                </template>
                                <template slot-scope="cuScope">
                                    <span v-if="pdfTransforming">{{ cuScope.row.scale }}</span>
                                    <el-input v-else :class="cuInputError(cuScope.row.scale, 'scale', cuScope.row, cuScope.$index) ? 'is-error' : ''" v-model.trim="cuScope.row.scale" placeholder="万元"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="citation" label="承运方式">
                                <template slot="header" slot-scope="cuScope">
                                    <span class="required">*</span><span>承运方式</span>
                                </template>
                                <template slot-scope="cuScope">
                                    <span v-if="pdfTransforming">{{ cuScope.row.citation }}</span>
                                    <el-input v-else :class="cuInputError(cuScope.row.citation, 'citation', cuScope.row, cuScope.$index) ? 'is-error' : ''" v-model.trim="cuScope.row.citation" placeholder="承运方式"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="customerType" label="客户品类">
                                <template slot="header" slot-scope="cuScope">
                                    <span class="required">*</span><span>客户品类</span>
                                </template>
                                <template slot-scope="cuScope">
                                    <span v-if="pdfTransforming">{{ cuScope.row.customerType }}</span>
                                    <el-input v-else :class="cuInputError(cuScope.row.customerType, 'customerType', cuScope.row, cuScope.$index) ? 'is-error' : ''" v-model.trim="cuScope.row.customerType"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="operationTime" label="运作时长">
                                <template slot="header" slot-scope="cuScope">
                                    <span class="required">*</span><span>运作时长</span>
                                </template>
                                <template slot-scope="cuScope">
                                    <span v-if="pdfTransforming">{{ cuScope.row.operationTime }}</span>
                                    <el-input v-else :class="cuInputError(cuScope.row.operationTime, 'operationTime', cuScope.row, cuScope.$index) ? 'is-error' : ''" v-model.trim="cuScope.row.operationTime"></el-input>
                                </template>
                            </el-table-column>
                        </el-table>
                        <span v-else>{{ scope.row.wdsm }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="pfbz" label="评分标准">
                    <template slot-scope="scope">
                        <div v-if="scope.$index === 0">
                            <div>1、有类似客户服务经验，有行业/线路经验（例：家电、快消、润滑油、服装、奶粉等）（10分）</div>
                            <div>-----近3年服务本客户本线路得10分；有本客户其它线路运作经验：6分；无对应行业经验：0分；</div>
                            <div>2、具有类似客户所属行业承运方式工作经验（例：整车、零担、冷链等）（5分）</div>
                            <div>-------有对应承运经验：5分；无对应承运经验：0分 </div>
                            <div>3、在该行业工作年限（5分）</div>
                            <div>-----3年以上5分；2～3年为3分；1-2年为1分，1年以下为0分</div>
                        </div>
                        <span v-else>{{ scope.row.pfbz }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="zf" label="总分" width="100"></el-table-column>
                <el-table-column prop="df" label="得分" width="100">
                    <template slot="header" slot-scope="scope">
                        <span class="required">*</span><span>得分</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input :class="scoreError(scope.row.df, scope.row.zf) ? 'is-error' : ''" v-model.trim="scope.row.df" placeholder="输入分数"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="resultFlag" label="结果" width="100"></el-table-column>
            </el-table>
            <div class="sub-title">2、财务风险</div>
            <el-table :data="riskTableData" :span-method="riArraySpanMethod" border header-row-class-name="header-bg">
                <el-table-column prop="pgwd" label="评估维度" width="120"></el-table-column>
                <el-table-column prop="wdsm" label="维度说明"></el-table-column>
                <el-table-column prop="pfbz" label="评分标准"></el-table-column>
                <el-table-column prop="zf" label="总分" width="100"></el-table-column>
                <el-table-column prop="df" label="得分" width="100">
                    <template slot="header" slot-scope="scope">
                        <span class="required">*</span><span>得分</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input :class="scoreError(scope.row.df, scope.row.zf) ? 'is-error' : ''" v-model.trim="scope.row.df" placeholder="输入分数"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="resultFlag" label="结果" width="100"></el-table-column>
            </el-table>
            <div class="sub-title">3、服务品质（由客户服务负责修订）</div>
            <el-table :data="serviceTableData" :span-method="svArraySpanMethod" border header-row-class-name="header-bg" class="margin-bottom-20">
                <el-table-column prop="pgwd" label="评估维度" width="120"></el-table-column>
                <el-table-column prop="wdsm" label="维度说明">
                    <template slot-scope="scope">
                        <div v-html="scope.row.wdsm"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="pfbz" label="评分标准"></el-table-column>
                <el-table-column prop="zf" label="总分" width="100"></el-table-column>
                <el-table-column prop="df" label="得分" width="100">
                    <template slot="header" slot-scope="scope">
                        <span class="required">*</span><span>得分</span>
                    </template>
                    <template slot-scope="scope">
                        <el-select v-if="scope.$index === 0" :class="isError(scope.row.df) ? 'is-error' : ''" v-model="scope.row.df" clearable>
                            <el-option label="有" :value="'有'"></el-option>
                            <el-option label="无" :value="'无'"></el-option>
                        </el-select>
                        <el-input v-else :class="scoreError(scope.row.df, scope.row.zf) ? 'is-error' : ''" v-model.trim="scope.row.df" placeholder="输入分数"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="resultFlag" label="结果" width="100"></el-table-column>
            </el-table>
            <div class="require-title">评审要求</div>
            <div class="require-rule margin-bottom-20">1、评审规则：资质信息任一项不符合不得引入；运营能力、服务品质各项总得分低于该项总分80%不得引入。</div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button :disabled="confirmLoading || pdfTransforming" @click="close">取 消</el-button>
            <el-button type="primary" :loading="confirmLoading || pdfTransforming" @click="confirm">确认提交</el-button>
            <!-- <el-button @click="generateAndUploadPDF('供应商评分表-运输【法人】.pdf')">生成PDF并上传</el-button> -->
        </span>
    </el-dialog>
</template>
<script>
import Decimal from 'decimal.js'
import BaseInfo from './BaseInfo.vue'
import scoreMixin from './scoreMixin.js';
import { onlineDetail, onlineSave } from '../../../../../../api/qualification.js';

// SRM_BASIC_QUALITY 供应商评分表-运输【法人】
const TYPE = '35'

const INIT_QT = [
    { businessType: '运输', propertyNature: '法人', zzlx: '营业执照\\法人身份证\\道路经营许可证', qualificationFlag: '', sm: '原则上此项中任何一条不符合不得引入。有特殊需求需走供应商特批引入。', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '成立年限必须在1年以上', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '提供可抵扣的运输增值税专用发票(必须是一般纳税人，税率9%、6%、3%）', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '无偷税漏税行为（电子税务局查询无欠税证明）', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '与集团人员无亲属关系（提供集团亲属关系盖章表）', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '无扣货、客户重大投诉、贿赂员工等不良记录', qualificationFlag: '', sm: '', resultFlag: '' },
]

const INIT_OT = [
    { pgwd: '同行业经验（提供上下游对应合同、结算等有效凭证）', wdsm: '', pfbz: '', zf: '20', df: '', resultFlag: '', customerList: [{}, {}, {}] },
    { pgwd: '运力资源', wdsm: '自有车辆，行驶证车辆所有人为该供应商公司', pfbz: '自有车辆3分/台，无自有车此项无分，此项最高得15分', zf: '15', df: '', resultFlag: '' },
    { pgwd: '', wdsm: '可调配车辆情况（挂靠车、合同车）：实际可调配车辆(供应商掌控自有车辆或者签有合约车辆)，挂靠车提供对应车辆挂靠证明、长合车提供合同证明；', pfbz: '可调配车辆1分/台，无可调配车辆此项无分，此项最高得5分', zf: '10', df: '', resultFlag: '' },
]
const INIT_RT = [
    { pgwd: '资金周转能力', wdsm: '应付账期：供应商可接受我司的付款周期', pfbz: '票后一个月5分；票后半月结为3分；票后周结为1分；每单结为0分。', zf: '5', df: '', resultFlag: '' },
    { pgwd: '', wdsm: '押金：可接受抵押风险及运作保证金5万以上、2-5万、2万以下、及有效固定资产抵押情况', pfbz: '5万以上为5分、5万～2万为3分、2万以下为2分、有效固定资产抵押5分', zf: '5', df: '', resultFlag: '' },
    { pgwd: '', wdsm: '垫资能力：垫资周期3月以上、2-3月、1-2月、10-25天、周结/现结', pfbz: '3个月以上10分、2-3月8分、1-2月6分；10-25天5分、周结或者现结1分', zf: '10', df: '', resultFlag: '' },
]
const INIT_ST = [
    { pgwd: '刚性条款', wdsm: '重大品质事件：发生过恶意扣货、堵门等严重事件', pfbz: '原则上不予采用此供应商', zf: '/', df: '', resultFlag: '' },
    { pgwd: '服务保障能力', wdsm: '人员组织保障：人力资源人力配备充足，组织架构、岗位职责清晰', pfbz: '人力资源满足上述条件得5分，少一项扣2分/个', zf: '5', df: '', resultFlag: '' },
    { pgwd: '', wdsm: '人员组织保障：人员符合岗位资质；名单中对接人员的最低同类岗位工作经验年限（含司机）', pfbz: '1-2年3分；2-3年4分；3年以上5分', zf: '5', df: '', resultFlag: '' },
    { pgwd: '', wdsm: '车辆质量保障：<br/>1、车辆年限5年以内（4分）；<br/>2、是否有禁行区域的具备通行证的备案车辆（3分）。<br/>3、车型/随车工具满足客户需求（3分）；', pfbz: '上限10分', zf: '10', df: '', resultFlag: '' },
    { pgwd: '商业险购买情况', wdsm: '为对应车辆、货物、随车人员购买商业险', pfbz: '查看投保记录：有5分，部分购买3分，无0分', zf: '5', df: '', resultFlag: '' },
    { pgwd: '体系标准', wdsm: '是否有体系文件：<br/>有品质、安全、sop相关体系文件及培训记录，SOP、紧急调车制度，回单、订单发运、在途操作规范，应急处理机制，对内考核机制。', pfbz: '查看体系文件、培训记录：有1项相关体系文件并且有培训记录计入2分；否则0分', zf: '5', df: '', resultFlag: '' },
    { pgwd: '', wdsm: '是否有考核应用：<br/>针对司机/下游供应商是否有按管理制度要求，输出相应的考评', pfbz: '查看考核通报/通知：3分/次，无0分', zf: '5', df: '', resultFlag: '' },
]

export default {
    components: { BaseInfo },
    mixins: [scoreMixin],
    data() {
        return {
            // SRM_YES,
            // currentId: null,
            // currentVersion: null,
            currentRow: null,
            visible: false,
            loading: false,
            confirmLoading: false,
            // pdfTransforming: false,

            qlfTableData: JSON.parse(JSON.stringify(INIT_QT)),
            operationTableData: JSON.parse(JSON.stringify(INIT_OT)),
            customerListCols: ['customerName', 'scale', 'citation', 'customerType', 'operationTime'],
            riskTableData: JSON.parse(JSON.stringify(INIT_RT)),
            serviceTableData: JSON.parse(JSON.stringify(INIT_ST)),
        };
    },
    methods: {
        open(row) {
            this.currentRow = row
            this.setUploadQlfForm(row)
            this.visible = true
            this.loading = true
            onlineDetail({ supplierCode: row.qualificationTypeCode, id: row.id }).then(res => {
                if (res && +res.code === 0) {
                    this.setData(res.data, JSON.parse(res.data.onlineContent || null))
                }
            }).finally(() => { this.loading = false })
        },
        close() {
            this.visible = false
            this.$refs.biRef.reset()
            this.qlfTableData = JSON.parse(JSON.stringify(INIT_QT))
            this.operationTableData = JSON.parse(JSON.stringify(INIT_OT))
            this.riskTableData = JSON.parse(JSON.stringify(INIT_RT))
            this.serviceTableData = JSON.parse(JSON.stringify(INIT_ST))
        },
        setData(baseInfo, data) {
            this.$refs.biRef.setBaseInfo(baseInfo)
            if (!data) {
                return false
            }
            this.$refs.biRef.setFormData(data.supplierInfo)
            this.qlfTableData[0].resultFlag = data.supplierQualification.resultFlag
            this.qlfTableData.forEach((item, index) => {
                item.qualificationFlag = data.supplierQualification['qualification' + (index + 1) + 'Flag']
            })
            this.operationTableData[0].resultFlag = data.operationalCapability.resultFlag
            this.operationTableData[0].customerList = data.operationalCapability.experience.customerList
            this.operationTableData[0].df = data.operationalCapability.experience.experienceScore
            this.operationTableData[1].df = data.operationalCapability.selfCarSocre
            this.operationTableData[2].df = data.operationalCapability.carInfoScore
            this.riskTableData[0].resultFlag = data.financialRisk.resultFlag
            this.riskTableData.forEach((item, index) => {
                item.df = data.financialRisk['risk' + (index + 1) + 'Score']
            })
            this.serviceTableData[0].resultFlag = data.serviceQuality.resultFlag
            this.serviceTableData.forEach((item, index) => {
                if (index === 0) {
                    item.df = data.serviceQuality.quality1Flag
                } else {
                    item.df = data.serviceQuality['quality' + (index + 1) + 'Score']
                }
            })
        },
        confirm() {
            const supplierInfo = this.$refs.biRef.getData()
            // 资质信息-是否符合-必填校验
            const qlfValid = this.qlfTableData.every(item => !!item.qualificationFlag)
            const clValid = this.customerListValidate()
            const scoreValid = this.scoreValidate()
            if (supplierInfo && qlfValid && clValid && scoreValid) {
                this.generateAndUploadPDF(this.currentRow.qualificationName + '.pdf', () => {
                    this.confirmLoading = true
                    onlineSave(this.getParams()).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success('提交成功!')
                            this.$emit('submit', this.getParamsFromUpload())
                            this.close()
                        }
                    }).finally(() => { this.confirmLoading = false })
                })
            } else {
                this.$message({
                    type: 'warning',
                    message: '请输入必填信息，字长不能超过20位(通讯地址100位)，运作规模、得分列请输入数字，可保留两位小数!',
                    duration: 4000,
                })
            }
        },
        // 运营能力-同行业经验-维度说明的表格校验
        customerListValidate() {
            let valid = true
            const { customerList } = this.operationTableData[0]
            // 判断所有行都无数据
            const allIsEmpty = customerList.every(item => !item.customerName)
            if (allIsEmpty) {
                valid = false
                return valid
            }
            // 过滤出有数据的行，并校验格式
            customerList.filter(item => this.customerListCols.some(key => !!item[key])).forEach(item => {
                this.customerListCols.forEach(key => {
                    if (['', null, undefined].includes(item[key]) || item[key].length > 20) {
                        valid = false
                    }
                    if (key === 'scale' && !/^\d+(\.\d{1,2})?$/.test(item.scale)) {
                        valid = false
                    }
                })
            })
            return valid
        },
        // 所有得分项格式校验
        scoreValidate() {
            const oError = this.operationTableData.some(item => this.scoreError(item.df, item.zf))
            const rError = this.riskTableData.some(item => this.scoreError(item.df, item.zf))
            const sError = this.serviceTableData.some((item, index) => {
                if (index === 0) {
                    return !item.df
                } else {
                    return this.scoreError(item.df, item.zf)
                }
            })
            return !oError && !rError && !sError
        },
        getParams() {
            const params = {
                type: TYPE,
                onlineContent: '',
                ...this.getParamsFromUpload()
            }
            const supplierInfo = this.$refs.biRef.getData()
            const supplierQualification = {
                resultFlag: this.qlfTableData[0].resultFlag,
            }
            this.qlfTableData.forEach((item, index) => {
                supplierQualification['qualification' + (index + 1) + 'Flag'] = item.qualificationFlag
            })
            const operationalCapability = {
                resultFlag: this.operationTableData[0].resultFlag,
                experience: {
                    experienceScore: this.operationTableData[0].df,
                    customerList: this.operationTableData[0].customerList,
                },
                selfCarSocre: this.operationTableData[1].df,
                carInfoScore: this.operationTableData[2].df,
            }
            const financialRisk = {
                resultFlag: this.riskTableData[0].resultFlag,
            }
            this.riskTableData.forEach((item, index) => {
                financialRisk['risk' + (index + 1) + 'Score'] = item.df
            })
            const serviceQuality = {
                resultFlag: this.serviceTableData[0].resultFlag,
            }
            this.serviceTableData.forEach((item, index) => {
                if (index === 0) {
                    serviceQuality.quality1Flag = item.df
                } else {
                    serviceQuality['quality' + (index + 1) + 'Score'] = item.df
                }
            })
            params.onlineContent = JSON.stringify({ supplierInfo, supplierQualification, operationalCapability, financialRisk, serviceQuality })
            return params
        },
        arraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if ([0, 1, 4, 5].includes(columnIndex)) {
                if (rowIndex === 0) {
                    return [6, 1];
                } else {
                    return [0, 0];
                }
            }
        },
        opArraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0) {
                if (rowIndex === 1) {
                    return [2, 1];
                } else if (rowIndex === 2) {
                    return [0, 0];
                }
            } else if (columnIndex === 5) {
                if (rowIndex === 0) {
                    return [3, 1];
                } else {
                    return [0, 0];
                }
            }
        },
        riArraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0) {
                if (rowIndex === 0) {
                    return [3, 1];
                } else {
                    return [0, 0];
                }
            } else if (columnIndex === 5) {
                if (rowIndex === 0) {
                    return [3, 1];
                } else {
                    return [0, 0];
                }
            }
        },
        svArraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0) {
                if (rowIndex === 1) {
                    return [3, 1];
                } else if (rowIndex === 5) {
                    return [2, 1];
                } else if ([2, 3, 6].includes(rowIndex)) {
                    return [0, 0];
                }
            } else if (columnIndex === 5) {
                if (rowIndex === 0) {
                    return [7, 1];
                } else {
                    return [0, 0];
                }
            }
        },
        cuInputError(val, prop, row, index) {
            let isError = false
            const allIsEmpty = this.customerListCols.every(key => ['', null, undefined].includes(row[key]))
            if (allIsEmpty) {
                isError = false
            } else if (prop === 'scale') {
                isError = !/^\d+(\.\d{1,2})?$/.test(val)
            } else {
                isError = ['', null, undefined].includes(val) || val.length > 20
            }
            return isError
        },
        isError(val) {
            return ['', null, undefined].includes(val)
        },
        scoreError(score, max) {
            // 不是可保留两位小数的数字格式 || 大于最大值
            return !/^\d+(\.\d{1,2})?$/.test(score) || Number(score) > Number(max)
        },
    },
    watch: {
        qlfTableData: {
            handler(val) {
                if (!this.visible) {
                    return val[0].resultFlag = ''
                }
                val[0].resultFlag = val.some(item => !item.qualificationFlag || item.qualificationFlag === '不符合') ? '不通过' : '通过'
            },
            deep: true,
        },
        operationTableData: {
            handler(val) {
                if (!this.visible) {
                    return val[0].resultFlag = ''
                }
                val[0].resultFlag = val.some(item => Number(item.df) > Number(item.zf) || Number(item.df) < Decimal.mul(item.zf, 0.8).toNumber()) ? '不通过' : '通过'
            },
            deep: true,
        },
        riskTableData: {
            handler(val) {
                if (!this.visible) {
                    return val[0].resultFlag = ''
                }
                val[0].resultFlag = val.some(item => Number(item.df) > Number(item.zf) || Number(item.df) < Decimal.mul(item.zf, 0.8).toNumber()) ? '不通过' : '通过'
            },
            deep: true,
        },
        serviceTableData: {
            handler(val) {
                if (!this.visible) {
                    return val[0].resultFlag = ''
                }
                if (!val[0].df || val[0].df === '有') {
                    val[0].resultFlag = '不通过'
                } else {
                    val[0].resultFlag = val.some((item, index) => index > 0 && (Number(item.df) > Number(item.zf) || Number(item.df) < Decimal.mul(item.zf, 0.8).toNumber())) ? '不通过' : '通过'
                }
            },
            deep: true,
        },
    },
}
</script>
<style lang="less">
.key-data-trans-legal-dialog {
    .el-dialog {
        margin-bottom: 0;
    }

    .el-dialog__body {
        overflow-y: scroll;
        padding: 0;
        height: calc(94vh - 113px);
        box-sizing: border-box;
    }

    .content-wrap {
        padding: 16px;
    }

    .title-container {
        // margin-bottom: 5px;
        font-size: 16px;
        color: #000;

        // i {
        //     float: right;
        //     padding-right: 10px;
        //     font-size: 24px;
        //     cursor: pointer;
        // }
    }

    .title {
        display: inline-block;
        font-weight: bold;

        &::before {
            display: inline-block;
            // border-radius: 50%;
            margin-right: 5px;
            width: 5px;
            height: 14px;
            background: #000;
            content: '';
            vertical-align: middle;
        }
    }

    .sub-title {
        padding: 5px 10px;
        font-size: 14px;
        color: #000;
        background-color: #f2f2f2;
    }

    .el-table {
        // border-right: 1px solid #ebeef5;

        .cell {
            white-space: normal;
        }

        .header-bg th {
            background: #f5f7fa;
        }
    }

    .margin-bottom-20 {
        margin-bottom: 20px;
    }

    .require-title {
        font-size: 16px;
        color: #000;
    }

    .el-dialog__footer {
        padding-top: 15px;
        padding-bottom: 15px;
        text-align: center;
        border-top: 1px solid #d7d7d7;

        .el-button + .el-button {
            margin-left: 30px;
        }
    }

    .required {
        color: #f96c5f;
    }

    .is-error input {
        border-color: #f96c5f;
    }
}
</style>